/** @format */

import React from "react";
import { Line } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';

interface ILastUsedChartsViewProps {
  chartData: {
    datasets: {
      label: string;
      data: { x: number; y: number }[];
      borderColor: string;
      backgroundColor: string;
      tension: number;
      pointHoverRadius: number;
      pointHitRadius: number;
    }[];
  };
  options: ChartOptions<'line'>;
}

const LastUsedChartsView: React.FC<ILastUsedChartsViewProps> = ({
  chartData,
  options,
}) => {
  return (
    <div style={{ width: '100%', height: 200, marginBottom: 10 }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default LastUsedChartsView;
